import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './HostEvent.module.scss';
import ButtonPill from '../../util/ButtonPill/ButtonPill';

const HostEvent = () => {
  const [isMounted, setIsMounted] = useState(false);
  const { t } = useTranslation(['marketing']);

  // Prevent hydration issues by not rendering until client-side
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <div className={styles.HostEvent}>
      <h2>{t('landing.hostEvent.title')}</h2>
      <ButtonPill type="ButtonWhiteWide" link="/dashboard">
        {t('landing.hostEvent.getStarted')}
      </ButtonPill>
    </div>
  );
};

export default HostEvent;
